import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { communityFeedApi } from 'src/Services/API';
import {
  editCommunityFeedItemCache,
  editCommunityFeedItemCommentsCache,
} from 'src/Services/API/cache';
import { CreateCommentDto, CommentDto } from 'src/Services/API/generated';

export type CreateCommunityFeedItemVariables = CreateCommentDto & { feedItemId: string };

export const useCreateCommunityFeedItemComment = (
  options?: UseMutationOptions<CommentDto, unknown, CreateCommunityFeedItemVariables>
) => {
  const queryClient = useQueryClient();

  return useMutation<CommentDto, unknown, CreateCommunityFeedItemVariables>(
    'create-community-feed-item-comment',
    async (data: CreateCommunityFeedItemVariables) => {
      const response = await communityFeedApi.communityFeedControllerCreateComment(
        data.feedItemId,
        data
      );

      return response.data;
    },
    {
      ...options,
      onSuccess(data, variables, context) {
        editCommunityFeedItemCache(queryClient, feedItem => {
          if (feedItem.id !== variables.feedItemId) return feedItem;

          return {
            ...feedItem,
            comments: {
              ...feedItem.comments,

              // Increase the comment count
              count: feedItem.comments.count + 1,
            },
          };
        });

        editCommunityFeedItemCommentsCache(queryClient, variables.feedItemId, undefined, data);

        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
